/* unplugin-vue-components disabled */import { render } from "./SidenavCollapse.vue?vue&type=template&id=f8a3a7ec"
import script from "./SidenavCollapse.vue?vue&type=script&lang=js"
export * from "./SidenavCollapse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../unionglobal-store-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__